// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-button[data-v-f7b14c90]{position:absolute;top:.75rem;right:.75rem}.icon-button.middle[data-v-f7b14c90]{position:absolute;top:50%;transform:translateY(-50%);right:.75rem}.pointer-none[data-v-f7b14c90]{pointer-events:none;background:#f5f5f5}.elevation[data-v-f7b14c90]{box-shadow:0 4px 12px rgba(0,0,0,.1)!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
